import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMant from '../../../../../components/extras/SidePanelMant';
import MPModal from '../../../../../components/MPModal';
import TableManttos from '../../../../../components/tables/tableMantto';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemNote } from '../../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';




export const MembersEquipmentsNotesPage = () => {
  const { menu, parameters, data } = useGlobalState();

  const [notes, setNotes] = useState<ItemNote[]>([]);
  const [note, setNote] = useState<ItemNote>();
  const [filteringText, setFilteringText] = useState("");




  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) {
        handleGetNote(parseInt(id))
      } else {
        setNote(undefined)
        handleGetNotes();
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleGetNote = async (idMaintenance: Number) => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/mants/get',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          idMaintenance: idMaintenance,
          images: true,
          logs: true
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.note) {
        setNote(data.note)
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleGetNotes = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/mants/list',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          images: true,
          month: parameters.period.split("-")[1],
          year: parameters.period.split("-")[0],
          orderBy: "dateSubmited",
          order: "desc"
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.notes) {
        setNotes(data.notes)
        setNote(undefined)
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (parameters?.years !== "") {
      handleGetNotes()
    }
  }, [parameters?.period]);


  const filteredRecords = notes.filter(note => {
    const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
    return searchWords.every(word =>
      note.keyw.toLowerCase().includes(word) ||
      note.registration.toLowerCase().includes(word)
    );
  });
  return (
    <CustomAppLayout
      toolsHide={true}
      splitPanelOpen={!!note}
      onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = "members/equipments/notes" : null}
      splitPanel={
        <SidePanelMant note={note ?? {}} />
      }
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">

          <Header variant="h1" actions={
            <>
              <Favorites />
            </>

          }>Notas {notes && notes.length > 0 ? " (" + notes.length + ")" : ""}</Header>

          <SpaceBetween direction="horizontal" size="xs">
            <FormField
              label="Fecha de consulta">
              <div style={{ width: 130 }}>
                <MPModal
                  width={120}
                  today prevMonth nextMonth
                  end={new Date()}
                  date={`${parameters.period}`}
                  onConfirm={(date) => {
                    setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                    setNote(undefined)
                  }}
                />
              </div>
            </FormField>
          </SpaceBetween>
          <TableManttos notes={notes} onSelect={(item: ItemNote) => window.location.hash = `#members/equipments/notes?id=${item.idMaintenance}`} />




        </SpaceBetween>
      }
    />
  );
};
